export type PublicRenderableSectionProjection = Readonly<{
  renderable?: boolean;
}>;

export function isPublicProfileSectionRenderable(
  projection: PublicRenderableSectionProjection | null | undefined,
): boolean {
  return projection?.renderable === true;
}

export function visiblePublicPortfolioItems<TItem>(
  portfolioProjection: (PublicRenderableSectionProjection & { items?: readonly TItem[] }) | null | undefined,
): readonly TItem[] {
  if (!isPublicProfileSectionRenderable(portfolioProjection) || !portfolioProjection?.items) {
    return [];
  }
  return portfolioProjection.items;
}
